// Import external libraries or custom JavaScript files
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "../channels";

// Initialize Rails, Turbolinks, and ActiveStorage
Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Import custom JavaScript files
import "../src/team_rounds_modal.js";
import "../src/menu.js";
import "../src/flash_alerts.js";
import "../src/score_validation.js";
import "../src/golfer_rounds_filter.js";
import "../src/partner_course_filter.js";
import "../src/tournament_field.js";
import "../src/tournament_progression.js";
import "../src/golfer_combo.js";
import "../src/tournament_golfer_table.js";
import "../src/team_matrix.js";
import "../src/segmented_control.js";
import "../src/nav_active.js";
import "../src/scorecard_sticky.js";
import "../src/partner_chart.js";
import "../src/scorecard_snap.js";
import "../src/tournament_form.js";
import "../src/practice_scorecard.js";
import '../stylesheets/application.scss';
